<div class="error-container">
  <div class="error-content">
    <h1 class="error-code">403</h1>
    <h2 class="error-title">Forbidden</h2>
    <p class="error-message">
      You don't have permission to access this resource.
    </p>
    <a routerLink="/links" class="error-link">Go to Links</a>
  </div>
</div>

